import { Injectable, Inject } from '@angular/core';
import { Observable } from 'rxjs';
import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';




@Injectable()
export class UsuariosService {

  myAppUrl: string = "";

  constructor(private http: HttpClient, @Inject('BASE_URL') baseUrl: string) {
    this.myAppUrl = baseUrl;
  }

  get() {
    return this.http.get(this.myAppUrl + 'api/Users/');
  }

  getAllUsers(isActive = true) {    
    return this.http.get(this.myAppUrl + 'api/Users/All?isActive=' + isActive);
  }

}
